var app = angular.module("leonardo");

var BreadcrumbController = function($scope, FilterService) {
  $scope.filterService = FilterService;
};

app.controller('BreadcrumbController', ['$scope', 'FilterService', BreadcrumbController]);
